import action from '../../../abstract/action.js';

export default action({
  label: 'Odpowiedz',
  icon: 'SendIcon',
  main: () => true,
  handle: async ({ $router, item: { id } }) => await $router.push({ name: 'mailing-stepper-reply', params: { id } }),
});